import { useEffect, useState } from 'react';
import { useOrderStore } from '../../../../store/useOrder';
import { formatDate } from '../../../../util/util';

/**
 * @author taulmax
 * @date 2024.11.17
 * @description 주문 확정 상세 페이지 - 10초후 새로고침 됩니다 텍스트
 */
const ODReloadText = () => {
  const [count, setCount] = useState<number>(10);
  const [date, setDate] = useState<string>('');
  const { orderDetail, getOrderDetail } = useOrderStore();

  useEffect(() => {
    // If the countdown reaches 0, call the API and reset to 10
    if (count === 0) {
      getOrderDetail(orderDetail?.id as string);
      setCount(10);
      setDate(`${formatDate(new Date()).timestamp}`);
    }

    // Set an interval to decrease the count every second
    const interval = setInterval(() => {
      setCount(prevCount => prevCount - 1);
    }, 1000);

    // Clear the interval when component unmounts or count changes
    return () => clearInterval(interval);
  }, [count, getOrderDetail, orderDetail?.id]);

  return (
    <div className="!flex !items-center !gap-2 !text-sm !text-gray-600">
      <svg className="!w-4 !h-4 !text-blue-500 !animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
      <span className="!font-medium">{count}초 후 자동 새로고침</span>
      {date && (
        <span className="!text-xs !text-gray-500">
          (최근: {date})
        </span>
      )}
    </div>
  );
};

export default ODReloadText;
